import {
  Button,
  Container,
  Group,
  Text,
  Title,
  createStyles,
} from '@mantine/core';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { Roles } from '../../enums/roles-enum';
import useAuth from '../../hooks/useAuth';

const useStyles = createStyles((theme) => ({
  root: {
    paddingTop: 80,
    paddingBottom: 80,
  },

  label: {
    textAlign: 'center',
    fontWeight: 900,
    fontSize: 220,
    lineHeight: 1,
    marginBottom: theme.spacing.xl * 1.5,
    color:
      theme.colorScheme === 'dark'
        ? theme.colors.dark[4]
        : theme.colors.gray[2],

    [theme.fn.smallerThan('sm')]: {
      fontSize: 120,
    },
  },

  title: {
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    textAlign: 'center',
    fontWeight: 900,
    fontSize: 38,

    [theme.fn.smallerThan('sm')]: {
      fontSize: 32,
    },
  },

  description: {
    maxWidth: 500,
    margin: 'auto',
    marginTop: theme.spacing.xl,
    marginBottom: theme.spacing.xl * 1.5,
  },
}));

function MissingPage() {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const { auth } = useAuth();

  return (
    <>
      <Helmet>
        <title>XPAY.World - Page not found</title>
      </Helmet>
      <Container className={classes.root}>
        <div className={classes.label}>404</div>
        <Title className={classes.title}>Page does not exist</Title>
        <Text
          color='dimmed'
          size='lg'
          align='center'
          className={classes.description}
        >
          Unfortunately, this is only a 404 page. You may have mistyped the
          address, or the page has been moved to another URL.
        </Text>
        <Group position='center'>
          <Button
            variant='subtle'
            size='md'
            onClick={() => {
              if (
                auth?.role === Roles.ADMINISTRATOR ||
                auth?.role === Roles.CHECKER ||
                auth?.role === Roles.SETTLEMENT
              ) {
                navigate('/admin');
              } else if (auth?.role === Roles.PARTNER) {
                navigate('/partner');
              } else if (auth?.role === Roles.RESELLER) {
                navigate('/reseller');
              } else if (auth?.role === Roles.MERCHANT) {
                navigate('/merchant');
              } else if (auth?.role === Roles.MERCHANT_BRANCH) {
                navigate('/branches');
              } else {
                navigate('/login');
              }
            }}
          >
            Take me back to home page
          </Button>
        </Group>
      </Container>
    </>
  );
}

export default MissingPage;
